import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'
import { useDataManagement } from '../../Hooks/useDataManagement'

import { DataManagementGrid } from '../Common'

import { privateNoteColumns } from '../../Data/PrivateNoteManagement/PrivateNoteListData'
import { getAllData, deleteIdData } from '../../lib/counselorcorner'

const AdminPrivateNoteList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()
	const { data, loading, searchQuery, setSearchQuery, handleDelete } = useDataManagement(getAllData, deleteIdData)
	const [showTable, setShowTable] = useState(false)

	const searchFields = ['ndate', 'instructorName', 'studentName', 'note']

	return (
		<DataManagementGrid
			title="Private Notes"
			subTitle="Manage private notes in the system"
			breadcrumbTitle="Private Notes"
			breadcrumbMainTitle="Private Notes"
			columns={privateNoteColumns}
			data={data}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search in private notes..."
			createButtonText="Add New Note"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/private-notes/create/${layout}`}
			onDelete={handleDelete}
			searchFields={searchFields}
			noDataMessage="No private notes found"
			showTable={showTable}
			additionalActionButton={
				<Button color="outline-info" onClick={() => setShowTable(!showTable)}>
					{showTable ? 'Hide' : 'Show'}
				</Button>
			}
		/>
	)
}

export { AdminPrivateNoteList }
